import { fetchCookie } from "./cookies";
import { clearAuthData } from "./tokenUtils";

interface CustomFetchOptions extends RequestInit {
  skipAuthRedirect?: boolean;
}

const customFetch = (
  url: string,
  options: CustomFetchOptions = {}
): Promise<Response> => {
  const token = fetchCookie("1Q_SPA");

  const headers = {
    ...options.headers,
  };

  if (token) {
    (headers as any)["Authorization"] = `Bearer ${token}`;
  }

  const { skipAuthRedirect, ...fetchOptions } = options;

  const finalOptions = {
    ...fetchOptions,
    headers,
  };

  return fetch(url, finalOptions).then((response) => {
    if (response.status === 401 && !skipAuthRedirect) {
      clearAuthData();
      window.location.href = "/sign-in/";
      return Promise.reject(new Error("Unauthorized - redirecting to login"));
    }
    return response;
  });
};

export default customFetch;
